export default "__VITE_ASSET__lTzS6yef__"